<template>
  <div class="space-between-y">
    <el-dialog :title="form.id ? '编辑执行团队' : '新建执行团队'" :visible.sync="dialog" width="460px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="团队名称" prop="name"><el-input v-model="form.name"/></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dialog=false">取消</el-button><el-button type="primary" :loading="saving" @click="save">保存</el-button></span>
    </el-dialog>

    <el-dialog title="团队成员" :visible.sync="memberDialog" width="620px">
      <el-table :data="members" border>
        <el-table-column prop="fullname" label="姓名"/><el-table-column prop="role" label="角色"/>
        <el-table-column prop="userPtrId" label="用户 ID" width="100"/>
      </el-table>
    </el-dialog>

    <div class="both-sides">
      <div class="space-between-x">
        <input-item label="关键字搜索" width="300"><el-input v-model="keyword" clearable placeholder="搜索团队名称" @keyup.enter.native="search"/></input-item>
        <input-item><el-button type="primary" @click="search">搜索</el-button></input-item>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建执行团队</el-button>
    </div>

    <el-table v-loading="loading" :data="list" border stripe>
      <el-table-column prop="name" label="团队名称"/>
      <el-table-column prop="memberCount" label="成员数" width="100" align="center"/>
      <el-table-column prop="createdAt" label="创建时间" width="190"/>
      <el-table-column label="操作" width="180" align="center">
        <template v-slot="scope">
          <el-button type="text" @click="showMembers(scope.row.id)">成员</el-button>
          <el-button type="text" @click="openEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-model="page" @updated="load"/>
  </div>
</template>

<script>
import InputItem from "@/components/base/layout/InputItem.vue";
import Pagination from "@/components/base/layout/Pagination.vue";
import {dealer} from "@/api/dealer";

export default {
  name: "DealerManage", components: {InputItem, Pagination},
  data() { return {keyword: "", list: [], loading: false, dialog: false, memberDialog: false, members: [], saving: false, form: {id: null, name: ""}, rules: {name: [{required: true, message: "请输入团队名称", trigger: "blur"}]}, page: {size: 10, current: 1, total: 0}}; },
  created() { this.load(); },
  methods: {
    load() { this.loading = true; dealer.list(this.page.size, this.page.current, this.keyword).then(res => { const data = res.data || {}; this.list = data.list || []; this.page.total = data.total || 0; }).finally(() => { this.loading = false; }); },
    search() { this.page.current = 1; this.load(); },
    openCreate() { this.form = {id: null, name: ""}; this.dialog = true; },
    openEdit(row) { this.form = {id: row.id, name: row.name}; this.dialog = true; },
    save() { this.$refs.form.validate(valid => { if (!valid) return; this.saving = true; (this.form.id ? dealer.update(this.form.id, this.form.name) : dealer.create(this.form.name)).then(() => { this.$message.success("保存成功"); this.dialog = false; this.load(); }).finally(() => { this.saving = false; }); }); },
    showMembers(id) { dealer.detail(id).then(res => { this.members = (res.data && res.data.members) || []; this.memberDialog = true; }); },
    remove(row) { this.$confirm(`确定删除执行团队「${row.name}」吗？`, "提示", {type: "warning"}).then(() => dealer.delete(row.id)).then(() => { this.$message.success("删除成功"); this.load(); }).catch(() => {}); },
  },
};
</script>

<style scoped>.danger { color: #f56c6c; }</style>
